import { createFileRoute } from '@tanstack/react-router';

// Content is now rendered by the layout based on the tab query param
export const Route = createFileRoute('/protected/_layout/forecast/_layout/')({
  component: () => null,
});
